/**
 * Runs `callback` once the browser is idle, or after `fallbackDelayMs` where
 * requestIdleCallback is unavailable (Safari). `timeoutMs` caps how long an
 * always-busy main thread can hold the callback back.
 */
export const runWhenIdle = (callback, { timeoutMs = 5000, fallbackDelayMs = 3000 } = {}) => {
  if (typeof window === 'undefined') return
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(callback, { timeout: timeoutMs })
  } else {
    setTimeout(callback, fallbackDelayMs)
  }
}

/**
 * Starts fetching an image at high priority before the element that shows it exists, so the
 * download overlaps the render work instead of following it. No-op for an empty URL or one
 * already preloaded.
 */
export const preloadImageWithHighPriority = (url) => {
  if (!url || typeof document === 'undefined') return
  const alreadyPreloaded = [...document.head.querySelectorAll('link[rel="preload"][as="image"]')]
    .some((link) => link.getAttribute('href') === url)
  if (alreadyPreloaded) return
  const link = document.createElement('link')
  link.setAttribute('rel', 'preload')
  link.setAttribute('as', 'image')
  link.setAttribute('href', url)
  link.setAttribute('fetchpriority', 'high')
  document.head.appendChild(link)
}
